module.exports = __webpack_public_path__ + "static/media/contact.497e7b20.svg";